module.exports = __webpack_public_path__ + "assets/img/2.de80760e.png";